import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

/** @public */
export const announcementsTranslationRef = createTranslationRef({
  id: 'announcements',
  messages: {
    announcementForm: {
      title: 'Title',
      excerpt: 'Excerpt',
      body: 'Content',
      active: 'Active',
      submit: 'Create Update',
      edit: 'Save',
      titlePlaceholder: 'Insert the title of the update (15 to 70 chars)',
      excerptPlaceholder:
        'Start writing the description of the update (50 to 120 chars)',
      cancel: 'Cancel',
      editAnnouncement: 'Edit announcement',
      newAnnouncement: 'New announcement',
      groupInput: 'Group',
      categoryInput: {
        create: 'Create',
        label: 'Category',
      },
    },
    announcementsPage: {
      newAnnouncement: 'New announcement',
      noAnnouncementHeading: 'No updates to show',
      noAnnouncementBody:
        'There are currently no updates available! They’ll will appear here once available',

      genericNew: 'New',
      card: {
        by: 'By',
        in: 'in',
        edit: 'EDIT',
        delete: 'DELETE',
      },
      grid: {
        announcementDeleted: 'Announcement deleted.',
      },
      contextMenu: {
        admin: 'Admin',
        categories: 'Categories',
      },
    },
    deleteDialog: {
      title: 'Are you sure you want to delete this announcement?',
      cancel: 'Cancel',
      delete: 'Delete',
    },
    announcementsCard: {
      seeAll: 'See all',
      announcements: 'Announcements',
      new: 'New',
      in: 'in',
      noAnnouncements: 'No announcements yet, want to',
      addOne: 'add one',
    },
    announcementSearchResultListItem: {
      published: 'Published',
      announcement: 'Updates',
    },
    announcementsTimeline: {
      noAnnouncements: 'No announcements',
      error: 'Error',
    },
    categoriesForm: {
      newCategory: 'New category',
      editCategory: 'Edit category',
      titleLabel: 'Title',
      submit: 'Submit',
    },
    categoriesTable: {
      categoryDeleted: 'Category deleted.',
      slug: 'Slug',
      title: 'Title',
      actions: 'Actions',
      addTooltip: 'Add',
      noCategoriesFound: 'No categories found.',
    },
    categoriesPage: {
      title: 'Categories',
      subtitle: 'Manage announcement categories',
    },
    createAnnouncementPage: {
      alertMessage: 'Announcement created.',
      alertMessageWithNewCategory: 'with new category',
    },
    editAnnouncementPage: {
      updatedMessage: 'Announcement updated.',
      notFoundMessage: 'Unable to find announcement',
      edit: 'Edit',
    },
    newAnnouncementBanner: {
      markAsSeen: 'Mark as seen',
      markAsReadFailed: 'Failed to mark announcement as read',
    },
    newCategoryDialog: {
      createdMessage: 'Category created.',
      newCategory: 'New category',
      title: 'Title',
      cancelButton: 'Cancel',
      createButton: 'Create',
    },
    subscription: {
      noUpdatesHeading: 'No update lists subscribed so far',
      noUpdatesBody:
        'Follow all the updates from specific teams. Add the first one you want to be on top of',
      subscribeModalHeading: 'Subscribe to updates',
      subscribeSearchGroup: 'Search by group',
      subscribeToListButton: 'Subscribe to list',
      subscribeButton: 'Subscribe',
      noSubscribedGroupsUpdatesHeading: 'No updates released so far',
      noSubscribedGroupsUpdatesBody:
        'We’ll notify you when this team sends their first update',
    },
    unSubscribe: {
      heading: 'Removing Subscription',
      body: 'You are about to remove the updates subscription for Automative Cloud. Are you sure you want to proceed with this action?',
      cancelButton: 'Cancel',
      unSubscribeButton: 'Remove',
    },
    admin: {
      adminPortal: {
        announcementsLabels: 'Announcements',
        categoriesLabel: 'Categories',
        title: 'Admin Portal for Announcements',
        subtitle: 'Manage announcements and categories',
      },
      announcementsContent: {
        alertMessage: 'Announcement created.',
        alertMessageWithNewCategory: 'with new category',
        cancelButton: 'Cancel',
        createButton: 'Create Announcement',
        announcements: 'Announcements',
        noAnnouncementsFound: 'No announcements found',
        table: {
          title: 'Title',
          body: 'Body',
          publisher: 'Publisher',
          publisherGroup: 'Publisher Group',
          category: 'Category',
          status: 'Status',
          actions: 'Actions',
          active: 'Active',
          inactive: 'Inactive',
        },
      },
      categoriesContent: {
        createdMessage: 'created',
        deletedMessage: 'Category deleted.',
        cancelButton: 'Cancel',
        createButton: 'Create category',
        table: {
          categoryDeleted: 'Category deleted.',
          slug: 'Slug',
          title: 'Title',
          actions: 'Actions',
          addTooltip: 'Add',
          noCategoriesFound: 'No categories found.',
        },
      },
    },
  },
});
